import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class LeftMenuService {
  private static readonly IS_CLOSE = "leftMenu.isClose";

  private readonly _isOpen$ = new BehaviorSubject<boolean>(
    !(localStorage.getItem(LeftMenuService.IS_CLOSE) ?? false)
  );

  get isOpen$() {
    return this._isOpen$.asObservable();
  }

  open() {
    const nextIsOpen = !this._isOpen$.value;

    this._isOpen$.next(nextIsOpen);

    if (!nextIsOpen) {
      return localStorage.setItem(LeftMenuService.IS_CLOSE, "true");
    }

    return localStorage.removeItem(LeftMenuService.IS_CLOSE);
  }
}
